import { render, staticRenderFns } from "./RegulationListItem.vue?vue&type=template&id=84b7ab90&scoped=true&"
import script from "./RegulationListItem.vue?vue&type=script&lang=js&"
export * from "./RegulationListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegulationListItem.vue?vue&type=style&index=0&id=84b7ab90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b7ab90",
  null
  
)

export default component.exports